module.exports = __webpack_public_path__ + "img/49.0b8bddb0.jpg";